import { memo } from 'react';

import { Tag } from '@air/next-icons';
import { IconButton, type IconButtonProps } from '@air/primitive-icon-button';
import { Tooltip } from '@air/primitive-tooltip';

export type EditTagsButtonProps = Pick<Required<IconButtonProps>, 'onClick'>;

export const EditTagsButton = memo(({ onClick }: EditTagsButtonProps) => (
  <Tooltip label="Edit Tags">
    <IconButton
      label="Edit Tags"
      appearance="ghost"
      color="grey"
      className="ui2:rounded-4 text-grey-1 hover:text-grey-10 active:text-grey-9"
      data-testid="SELECTION_ACTION_BAR_EDIT_TAGS"
      onClick={onClick}
      size="small"
    >
      <Tag className="size-4" />
    </IconButton>
  </Tooltip>
));

EditTagsButton.displayName = 'EditTagsButton';
